import { getObjectProp } from "@reco-m/core";

/**
 * 是否在Header里调用查询工单的接口
 */
export const IS_GET_ORDER_ON_HEADER = getObjectProp(client, "isgetOrderOnHeader", true);

/**
 * 是否开启行政审批
 */
export const IS_OPEN_RECRUIT = getObjectProp(client, "app.openRecruit", false);
/**
 * 是否开启招聘
 */
export const IS_OPEN_ENTERPRISE_HOME = getObjectProp(client, "app.openEnterpriseHome", false);
/**
 * 是否开启企业主页
 */
export const IS_OPEN_ADMIN_APPROVAL = getObjectProp(client, "app.openAdminiApproval", false);
/**
 * 是否开启政策申报
 */
export const IS_OPEN_POLICY_DECLARE = getObjectProp(client, "app.openPolicyDeclare", false);
/**
 * 是否开启企业账单
 */
export const IS_OPEN_BUSINESS_BILL = getObjectProp(client, "app.openBusinessBill", false);
